export default __webpack_public_path__ + "static/fox-hub-2 1-586da8ad65898c1cb55eddd8d5bd9785.png";